<template>
    <div class="fp">
        <div class="file-preview">
            <div v-if="!isRecursive" class="file-preview-footer">
                <button type="button" class="fp-close" aria-label="Kapat" @click="close">
                    <span class="material-symbols-outlined">close</span>
                </button>
            </div>
            <div class="file-preview-content" :class="{ 'file-preview-content-eyp': mutableViewer == 'eyp' }">
                <div class="fp-eyp" v-if="data && mutableViewer == 'eyp'">
                    <div class="fp-title">{{data.FileName}}</div>
                    <div class="fp-sub">
                        {{data.Size | prettyBytes}}
                        <span class="fp-sub-dot">•</span>
                        Ver: {{data.Version}}
                    </div>

                    <div class="fp-card">
                        <div class="fp-card-title">Üstveri</div>
                        <div class="fp-row fp-row-stack">
                            <span class="fp-label">Üstyazı</span>
                            <div class="fp-value">
                                <!-- <button type="button" @click="download('ustyazi')" class="btn btn-link" style="padding:0;">{{data.Ustveri.DosyaAdi}}</button> -->
                                <file-download-link :document="data.Ustyazi" :isOnlineView="isOnlineView" :voya="true" @download="downloadEypAttachment" @preview="showEypAttachment"></file-download-link>
                            </div>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Tarih</span>
                            <span class="fp-value">{{data.Ustveri.Tarih | date }}</span>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Belge Tekil No</span>
                            <span class="fp-value">{{data.Ustveri.BelgeId}}</span>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Tekil Anahtar</span>
                            <span class="fp-value">{{data.Ustveri.OzId}}</span>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Belge No</span>
                            <span class="fp-value">{{data.Ustveri.BelgeNo}}</span>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Konu</span>
                            <span class="fp-value">{{data.Ustveri.Konu}}</span>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Güvenlik Derecesi</span>
                            <span class="fp-value">
                                {{data.Ustveri.GuvenlikKodu | eypSecurityCode }}
                                <div class="fp-muted" v-if="data.Ustveri.GuvenlikDerecesiTarihi">({{data.Ustveri.GuvenlikDerecesiTarihi | date }})</div>
                            </span>
                        </div>
                        <div class="fp-row">
                            <span class="fp-label">Oluşturan</span>
                            <span class="fp-value">
                                <button type="button" @click="showOzne(data.Ustveri.Olusturan, 'Oluşturan Bilgileri')" class="fp-link">{{data.Ustveri.Olusturan.Adi}}</button>
                            </span>
                        </div>
                        <div class="fp-row fp-row-stack">
                            <span class="fp-label">Dağıtımlar</span>
                            <div class="fp-value fp-list">
                                <button type="button" class="fp-link" @click="showOzne(d.Item, 'Dağıtım Bilgileri')" v-for="d in data.Ustveri.Dagitimlar" :key="d.KKK">
                                    {{d.Item.Adi}}
                                </button>
                            </div>
                        </div>
                        <div class="fp-row fp-row-stack">
                            <span class="fp-label">Ekler</span>
                            <div class="fp-value fp-list">
                                <div v-for="d in data.Ustveri.Ekler" :key="d.Id">
                                    <file-download-link :document="convertEypAttachmentToDocument(d)" :isOnlineView="isOnlineView" :voya="true" @download="downloadEypAttachment" @preview="showEypAttachment"></file-download-link>
                                    <!-- <button @click="download(d.Id)" class="btn btn-link" style="padding:0; text-align:left;">
                                        {{d.Ad}}
                                    </button> -->
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="fp-card" v-if="data.BelgeHedef && data.BelgeHedef.length">
                        <div class="fp-card-title">Belge Hedef</div>
                        <div class="fp-list">
                            <div v-for="h in data.BelgeHedef" :key="h.Adi">
                                <button type="button" class="fp-link" @click="showOzne(h, 'Belge Hedef Bilgileri')">
                                    {{h.Adi}}
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="fp-card">
                        <div class="fp-card-title">Belge İmza</div>
                        <div class="fp-list">
                            <div v-for="h in data.BelgeImza" :key="h.Adi">
                                <button type="button" class="fp-link" @click="showOzne(h.Imzalayan, 'İmzacı Bilgileri')">
                                    {{h.Imzalayan.Adi}}
                                </button>
                            </div>
                        </div>
                        <div v-if="!data.BelgeImza || data.BelgeImza.length == 0" class="fp-empty">
                            İmza yok.
                        </div>
                    </div>
                    <file-preview v-if="eypFileDetail" :file="eypFileDetail" :isOnlineView="isOnlineView" :viewer="eypFileViewer" :isRecursive="true" @close="closeEypModal"></file-preview>
                </div>
                <div class="container-fluid" v-else-if="mutableViewer == 'office'">
                    <div v-if="iframeUrl" class="text-center text-muted" >
                        <iframe class="fp-office-frame" :src="iframeUrl" frameborder="0" width="100%" :height="deviceHeight" ></iframe>
                    </div>
                    <div v-else class="fp-loading">
                        <span class="fp-spinner"></span>
                        Yükleniyor...
                    </div>
                </div>
                <div class="container-fluid" v-else-if="mutableViewer == 'text'">
                    <div v-if="iframeUrl" class="text-muted" >
                        <TextViewer :url="iframeUrl"></TextViewer>
                    </div>
                    <div v-else class="fp-loading">
                        <span class="fp-spinner"></span>
                        Yükleniyor...
                    </div>
                </div>
                <div class="container-fluid" v-else-if="mutableViewer == 'code'">
                    <div v-if="iframeUrl" class="text-muted" >
                        <MarkdownViewer :url="iframeUrl"></MarkdownViewer>
                    </div>
                    <div v-else class="fp-loading">
                        <span class="fp-spinner"></span>
                        Yükleniyor...
                    </div>
                </div>
                <div class="pdf-cont" v-else-if="mutableViewer == 'pdf'">
                    <div v-if="iframeUrl" style="width: 100%;">
                        <PDFViewer :pdfUrl="iframeUrl"></PDFViewer>
                    </div>
                    <div v-else class="fp-loading">
                        <span class="fp-spinner"></span>
                        Yükleniyor...
                    </div>
                </div>
                <div class="container-fluid" v-else-if="mutableViewer == 'image'">
                    <div v-if="iframeUrl" class="text-muted" >
                        <img :class="{ 'originalImageSize': viewOriginal, 'image': viewFitted }" :src="iframeUrl" alt="">
                        <div class="viewOriginalButtonContainer">
                                <button class="btn btn-sm text-white viewOriginalButton" @click="viewOriginalImageSize">
                                    <span v-if="!viewOriginal">Orijinal Boyut</span>
                                    <span v-else>Ekrana Sığdır</span>
                                </button>
                        </div>
                    </div>
                    <div v-else class="fp-loading">
                        <span class="fp-spinner"></span>
                        Yükleniyor...
                    </div>
                </div>
                <div class="container-fluid" v-else-if="mutableViewer != 'eyp'">
                    <iframe class="iframe" v-if="iframeUrl" :src="iframeUrl"></iframe>
                    <div v-else class="fp-loading">
                        <span class="fp-spinner"></span>
                        Yükleniyor...
                    </div>
                </div>
                <div v-else-if="error" class="fp-error">
                    {{error.Message}}
                    <div v-for="(e, i) in error.ModelState" :key="i">
                        <div v-for="(a, ai) in e" :key="ai">{{a}}</div>
                    </div>
                </div>
                <div v-else class="fp-loading">
                    <span class="fp-spinner"></span>
                    Yükleniyor...
                </div>
                <!-- <code>{{file}}</code>
                <hr>
                <code>{{data}}</code> -->
            </div>
        </div>

        <!-- ÖZNE PREVIEW -->
        <bottom-sheet v-if="ozne" :title="ozneTitle || 'Detaylar'" @close="ozne = null">
            <div class="fp-sheet-section">{{ozne.Kind | ozneKind}} Bilgileri</div>
            <template v-if="ozne.Kind == 'KurumKurulus'">
                <div class="fp-row">
                    <span class="fp-label">Adı</span>
                    <span class="fp-value">{{ozne.Adi}}</span>
                </div>
                <div class="fp-row" title="Kurum Kimlik Kodu">
                    <span class="fp-label">K. K. Kodu</span>
                    <span class="fp-value">{{ozne.KKK}}</span>
                </div>
            </template>
            <template v-else-if="ozne.Kind == 'GercekSahis'">
                <div class="fp-row" title="T.C. Kimlik No">
                    <span class="fp-label">T.C.K.N</span>
                    <span class="fp-value">{{ozne.TCKN}}</span>
                </div>
                <div class="fp-row">
                    <span class="fp-label">Adı</span>
                    <span class="fp-value">{{ozne.Adi}}</span>
                </div>
                <div class="fp-row" v-show="ozne.Unvan">
                    <span class="fp-label">Unvan</span>
                    <span class="fp-value">{{ozne.Unvan}}</span>
                </div>
            </template>
            <template v-else-if="ozne.Kind == 'TuzelSahis'">
                <div class="fp-row" title="T.C. Kimlik No">
                    <span class="fp-label">Mersis No</span>
                    <span class="fp-value">{{ozne.MersisNo}}</span>
                </div>
                <div class="fp-row">
                    <span class="fp-label">Id</span>
                    <span class="fp-value">{{ozne.Id}}</span>
                </div>
                <div class="fp-row">
                    <span class="fp-label">Adı</span>
                    <span class="fp-value">{{ozne.Adi}}</span>
                </div>
            </template>

            <div class="fp-sheet-section">İletişim Bilgileri</div>
            <template v-if="ozne.IletisimBilgisi">
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Telefon">
                    <span class="fp-label">Telefon</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Telefon}}</span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Telefon2">
                    <span class="fp-label">Telefon 2</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Telefon2}}</span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.EPosta">
                    <span class="fp-label">E-Posta</span>
                    <span class="fp-value"><a class="fp-anchor" :href="'mailto:' + ozne.IletisimBilgisi.EPosta">{{ozne.IletisimBilgisi.EPosta}}</a></span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Faks">
                    <span class="fp-label">Faks</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Faks}}</span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Web">
                    <span class="fp-label">Web</span>
                    <span class="fp-value"><a class="fp-anchor" :href="ozne.IletisimBilgisi.Web">{{ozne.IletisimBilgisi.Web}}</a></span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Adres">
                    <span class="fp-label">Adres</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Adres}}</span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Ilce">
                    <span class="fp-label">İlçe</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Ilce}}</span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Il">
                    <span class="fp-label">İl</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Il}}</span>
                </div>
                <div class="fp-row" v-if="ozne.IletisimBilgisi.Ulke">
                    <span class="fp-label">Ülke</span>
                    <span class="fp-value">{{ozne.IletisimBilgisi.Ulke}}</span>
                </div>
            </template>
            <button type="button" class="fp-sheet-close" @click="ozne = null">Kapat</button>
        </bottom-sheet>
        <!-- ÖZNE PREVIEW SONU -->
    </div>
</template>
<script>
import axios from 'axios'
import fileDownloadLink from '../components/FileDownloadLink.vue'
import MarkdownViewer from './DocPreview/MarkdownViewer.vue';
import TextViewer from './DocPreview/TextViewer.vue';
import PDFViewer from './PDFComponent/PDFViewer.vue';
import BottomSheet from './Voya/BottomSheet.vue';


export default {
    name: "FilePreview",
    components: {
    PDFViewer,
    fileDownloadLink,
    MarkdownViewer,
    TextViewer,
    BottomSheet
    },
    props: {
        file: {
            type: Object,
            required: true
        },
        viewer: {
            type: String,
            default: 'eyp'
        },
        isOnlineView: {
            type: Boolean,
            default: true
        },
        customHeight: {
            type: Boolean,
            default: false
        },
        isRecursive: {
            type: Boolean,
            default: false
        },
    },
    data(){
        
        return {
            pageCount: 1,
            data: null,
            error: null,
            ozne: null,
            ozneTitle: null,
            iframeUrl: null,
            width : screen.width*0.6,
            subFileDetail:null,
            mutableFile: this.file,
            mutableViewer: this.viewer,
            pdfData: null,
            viewOriginal: false,
            viewFitted: true,
            deviceHeight: 400,
            eypFileDetail: null,

        };
    },
    created(){
        document.getElementsByTagName('body')[0].style = 'overflow:hidden';
        this.deviceHeight = screen.height - 80;
        switch(this.mutableViewer){
            case "eyp":
                axios.post('previeweyp/post', {
                    EntityId : this.mutableFile.EntityId,
                    DocumentId: this.mutableFile.Id,
                    EntityType: this.mutableFile.EntityType ?? "Job"
                }, { silent: true }).then(x => {
                    this.data = x.data;
                })
                .catch(x => {
                    console.log('Önizleme verisi alınamadı.', x.response);
                    this.error = x.response.data;
                })
                break;
            case "pdf":
                this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                    //this.getPdfData();
                })
                break;
            case "office":
            this.getDownloadUrl()
                .then(x => {
                    this.iframeUrl = 'https://view.officeapps.live.com/op/embed.aspx?src=' + x.data.Data.Url;
                })
                break;
            case "text":
            this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "code":
            this.getDownloadUrl()
                .then(x => {
                    console.log(x)
                    this.iframeUrl = x.data.Data.Url;
                })
                break;
            case "image":
            this.getDownloadUrl()
                .then(x => {
                    var imageUrl = x.data.Data.Url;
                    console.log(x)
                    fetch(imageUrl)
                        .then((response) => response.blob())
                        .then((blob) => {
                        // SVG dosyaları sunucudan farklı bir içerik türüyle gelirse <img> içinde görüntülenemez
                        var fileName = this.mutableFile.FileName || (this.mutableFile.UnsignedFile && this.mutableFile.UnsignedFile.FileName) || "";
                        if (/\.svg$/i.test(fileName) && blob.type != "image/svg+xml")
                            blob = new Blob([blob], { type: "image/svg+xml" });
                        const reader = new FileReader();
                        reader.onloadend = () => {
                            this.iframeUrl = reader.result;
                        };
                        reader.readAsDataURL(blob);
                    });
                })
                break;
            default:
                this.getDownloadUrl()
                .then(x => {
                    this.iframeUrl = this.viewerUrl + x.data.Data.Url;
                })
                break;
        }

        
    },
    mounted(){
        // Office iframe'inin yüksekliği ekran yüksekliği yerine önizleme alanının gerçek yüksekliği olur
        var content = this.$el.querySelector('.file-preview-content');
        if(content && content.clientHeight)
            this.deviceHeight = content.clientHeight;
    },
    destroyed(){
        document.getElementsByTagName('body')[0].style = '';
    },
    computed: {
        viewerUrl(){
            return this.mutableViewer == 'office365' ? 'https://view.officeapps.live.com/op/view.aspx?src=' : 'https://docs.google.com/gview?embedded=true&url=';
        }
    },
    methods:{
        closeEypModal(){
            this.eypFileDetail = null;
        },
        viewOriginalImageSize(){
            this.viewFitted = !this.viewFitted;
            this.viewOriginal = !this.viewOriginal;
        },
        getPdfData(){
            if(this.pdfData){
                return;
            }
            else {
                axios({
                    url: this.iframeUrl, //your url
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    
                    // create file link in browser's memory
                   // this.pdfData =  response.data;
                   new Response(response.data).arrayBuffer().then((d)=> {
                    this.pdfData = new Uint8Array(d);
                   });
                });
            }
        },
        createdCopy(){
            document.getElementsByTagName('body')[0].style = 'overflow:hidden';

            switch(this.mutableViewer){
                case "eyp":
                    axios.post('previeweyp/post', {
                        EntityId : this.mutableFile.EntityId,
                        DocumentId: this.mutableFile.Id,
                        EntityType: this.mutableFile.EntityType ?? "Job"
                    }).then(x => {
                        this.data = x.data;
                    })
                    .catch(x => {
                        console.log('Önizleme verisi alınamadı.', x.response);
                        this.error = x.response.data;
                    })
                    break;
                case "pdf":
                    this.getDownloadUrl()
                    .then(x => {
                        console.log("pdf",x)
                        this.iframeUrl = x.data.Data.Url;
                        //this.getPdfData();
                    })
                    break;
                case "office":
                this.getDownloadUrl()
                    .then(x => {
                        this.iframeUrl = x.data.Data.Url;
                    })
                    break;
                case "text":
                this.getDownloadUrl()
                    .then(x => {
                        console.log(x)
                        this.iframeUrl = x.data.Data.Url;
                    })
                    break;
                case "code":
                this.getDownloadUrl()
                    .then(x => {
                        console.log(x)
                        this.iframeUrl = x.data.Data.Url;
                    })
                    break;
                case "image":
                this.getDownloadUrl()
                    .then(x => {
                        var imageUrl = x.data.Data.Url;
                        console.log(x)
                        fetch(imageUrl)
                            .then((response) => response.blob())
                            .then((blob) => {
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                this.iframeUrl = reader.result;
                            };
                            reader.readAsDataURL(blob);
                        });
                    })
                    break;
                default:
                    this.getDownloadUrl()
                    .then(x => {
                        this.iframeUrl = this.viewerUrl + x.data.Data.Url;
                    })
                    break;
            }
        },
        handleDocumentRender() {
        this.isLoading = false
        this.pageCount = this.$refs.pdfRef.pageCount
        },
        close(){
            if(this.eypFileDetail)
                this.closeEypModal();
            else
                this.$emit('close');
        },
        showOzne(ozne, title){
            this.ozne = ozne;
            this.ozneTitle = title;
        },
        download(attachmentId){
            
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/previeweyp/createDocumentUrl/`, {
                  EntityId : this.mutableFile.EntityId,
                  DocumentId: this.mutableFile.Id,
                  AttachmentId: attachmentId,
                  EntityType: this.mutableFile.EntityType ?? "Job"
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url);
              })
              .catch(x => window.processErrorResponse(x, this));
        },
        convertEypAttachmentToDocument(data){
            var result = {...data};
            result.AttachmentId = data.Id;
            result.FileName = data.Ad;
            return result;
        },
        downloadEypAttachment(attachment, menuKey){
            // İndirilecek doküman için dinamik URL'i alır ve tarayıcıyı bu adrese yönlendirir.
            return axios
              .post(`/previeweyp/createDocumentUrl/`, {
                  EntityId : this.mutableFile.EntityId,
                  DocumentId: this.mutableFile.Id,
                  AttachmentId: attachment.AttachmentId,
                  EntityType: this.mutableFile.EntityType ?? "Job"
              })
              .then(x => {
                console.log("createDocumentUrl Result:", x.data);
                window.open(x.data.Data.Url+ (menuKey == 'view' ? "&view=true" : ""));
              })
              .catch(x => window.processErrorResponse(x, this));
        },

        showEypAttachment(document,type){
            var oldDoc = {...this.mutableFile};
            this.eypFileDetail = document;
            this.eypFileViewer = type;
            this.eypFileDetail.DocumentId = oldDoc.Id;
            this.eypFileDetail.EntityId = oldDoc.EntityId;
            this.eypFileDetail.OldEntityType = oldDoc.EntityType;
            this.eypFileDetail.EntityType = "eyp";

        },
        getDownloadUrl(){
            var entityType = this.mutableFile.EntityType ?? "job";
            var url = "";
            var obj = { EntityId : this.mutableFile.EntityId ? this.mutableFile.EntityId : this.mutableFile.Document.EntityId  };
            if(entityType == "job"){
                url = this.mutableFile.UnsignedFile ? `/job/createDocumentUrl/` : `/job/createAttachmentUrl/`;
                obj.IsFormatted = this.mutableFile.IsFormatted;
                if(this.mutableFile.SignedFile && this.mutableFile.IsSigned) {
                    obj.DocumentId = this.mutableFile.Id;
                    obj.IsSigned = true;
                } else if(this.mutableFile.UnsignedFile) {
                    obj.DocumentId = this.mutableFile.Id;
                    obj.IsSigned = false;
                } else {
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }else if(entityType == "IncomingDoc"){
                url = this.mutableFile.DocumentId ? `/incomingDoc/createDocumentUrl/` : `/incomingDoc/createAttachmentUrl/`;
                
                if(this.mutableFile.Id)
                  obj.DocumentId = this.mutableFile.Id;

                  if(this.mutableFile.DocumentId)
                  obj.DocumentId = this.mutableFile.DocumentId;

            }else if(entityType == "eyp"){
                url =  `/previeweyp/createDocumentUrl/`;
                obj.DocumentId = this.mutableFile.DocumentId;
                obj.AttachmentId = this.mutableFile.AttachmentId;
                obj.EntityType = this.mutableFile.OldEntityType;
            }
            else if(entityType == "Rem"){
                url = this.mutableFile.DocumentId ? `/rembox/createDocumentUrl/` : `/rembox/createAttachmentUrl/`;
                
                if(this.mutableFile.Id){
                    obj.EntityId = this.mutableFile.EntityId;
                    obj.AttachmentId = this.mutableFile.Id;
                }
            }
            return axios.post(url, obj, { silent: true });
        }
    }
}
</script>
<style scoped>
    /* Voya: dosya önizleme */
    .fp {
        font-family: 'Poppins', Avenir, Helvetica, Arial, sans-serif;
        color: #092154;
    }

    .container-fluid{
        padding-right: 0px !important;
        padding-left: 0px !important;
    }
    .file-preview {
        position:fixed;
        top: calc(57px + env(safe-area-inset-top, 0px));
        right:0;
        bottom:0;
        left:0;
        background:#FFF;
        z-index: 1;
    }

    .file-preview-content {
        position:fixed;
        background: #EEF0F4;
        top: calc(57px + env(safe-area-inset-top, 0px));
        right: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
    }

    .file-preview-content-eyp {
        background: #F8F8F8;
    }

    .file-preview-footer {
        z-index: 999;
        position: fixed;
        top: calc(57px + env(safe-area-inset-top, 0px) + 12px);
        right: 12px;
    }

    .fp-close {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 44px;
        height: 44px;
        padding: 0;
        border: 1px solid #EFEFEF;
        border-radius: 50%;
        background-color: #ffffff;
        box-shadow: 0 2px 12px rgba(9, 33, 84, 0.18);
        color: #092154;
        font-size: 24px;
    }

    .fp-close:active {
        background-color: #F4F6FA;
    }

    /* Office görüntüleyici: iframe akış içinde kalır; yüksekliği önizleme alanına eşitlenir (deviceHeight) */
    .fp-office-frame {
        display: block;
        border: 0;
    }

    .iframe {
        position: fixed;
        left: 0;
        right: 0;
        width: 100%;
        top: 59px;
        bottom: 50px;
        height: calc(100% - 113px);
    }
    .imageFrame {
        position: fixed;
        left: 0;
        right: 0;
        width: 100vw;
        top: 59px;
        bottom: 50px;
        height: 100vh;
    }
    .image{
        width: 100vw;
    }
    .originalImageSize{
        width: auto;
    }
    .viewOriginalButtonContainer{
        position: fixed;
        bottom: calc(env(safe-area-inset-bottom, 0px) + 16px);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .viewOriginalButton{
        padding: 0 20px;
        height: 40px;
        background-color: #092154;
        border-radius: 100px;
        border: 1px solid transparent;
        box-shadow: 0 2px 12px rgba(9, 33, 84, 0.3);
        font-family: inherit;
        font-weight: 500;
        font-size: 13px;
        width: fit-content;
    }
    .pdf-container{
        height: 100%;
        display: flex;
        justify-content: center;
    }
    .pdf-outer-container{
        background-color: #ccc;
        height: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
    }
    .pdf-cont{
        padding: 30px;
        position: absolute;
        left: 0;
        right: 0;
    }

    /* Yükleniyor / hata durumları */
    .fp-loading {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 100px 0;
        font-weight: 500;
        font-size: 13px;
        color: #808080;
    }

    .fp-spinner {
        width: 18px;
        height: 18px;
        border: 2px solid #FCE3CE;
        border-top-color: #F37615;
        border-radius: 50%;
        animation: fp-spin 0.8s linear infinite;
    }

    @keyframes fp-spin {
        to {
            transform: rotate(360deg);
        }
    }

    .fp-error {
        padding: 100px 24px;
        text-align: center;
        font-size: 14px;
        line-height: 150%;
        color: #DC3545;
    }

    /* EYP üstveri */
    .fp-eyp {
        padding: 16px 16px calc(env(safe-area-inset-bottom, 0px) + 24px) 16px;
    }

    .fp-title {
        padding-right: 56px;
        font-weight: 600;
        font-size: 16px;
        line-height: 140%;
        color: #092154;
        word-break: break-all;
    }

    .fp-sub {
        margin-top: 2px;
        font-size: 12px;
        color: #808080;
    }

    .fp-sub-dot {
        margin: 0 4px;
    }

    .fp-card {
        box-sizing: border-box;
        margin-top: 12px;
        padding: 16px;
        border: 1px solid #EFEFEF;
        border-radius: 16px;
        background-color: #ffffff;
        box-shadow: 0 2px 12px rgba(9, 33, 84, 0.06);
    }

    .fp-card-title {
        margin-bottom: 4px;
        font-weight: 600;
        font-size: 16px;
        line-height: 140%;
        color: #092154;
    }

    .fp-row {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        padding: 12px 0;
        min-height: 24px;
    }

    .fp-row + .fp-row {
        border-top: 1px solid #EFEFEF;
    }

    .fp-row-stack {
        flex-direction: column;
        gap: 6px;
    }

    .fp-label {
        flex-shrink: 0;
        font-weight: 400;
        font-size: 14px;
        line-height: 140%;
        color: #808080;
    }

    .fp-value {
        min-width: 0;
        text-align: right;
        font-weight: 500;
        font-size: 14px;
        line-height: 140%;
        color: #333333;
        word-break: break-word;
    }

    .fp-row-stack .fp-value {
        width: 100%;
        text-align: left;
    }

    .fp-muted {
        font-weight: 400;
        font-size: 12px;
        color: #808080;
    }

    .fp-list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .fp-link {
        padding: 0;
        border: none;
        background: transparent;
        text-align: left;
        font-family: inherit;
        font-weight: 500;
        font-size: 14px;
        line-height: 140%;
        color: #097DFF;
    }

    .fp-anchor {
        color: #097DFF !important;
        text-decoration: none !important;
    }

    .fp-empty {
        padding: 8px 0;
        text-align: center;
        font-style: italic;
        font-size: 13px;
        color: #808080;
    }

    .fp-sheet-section {
        margin: 8px 0 0 0;
        font-weight: 600;
        font-size: 14px;
        color: #092154;
    }

    .fp-sheet-close {
        width: 100%;
        height: 48px;
        margin-top: 16px;
        padding: 0 16px;
        border: 1px solid #182F5E;
        border-radius: 8px;
        background-color: #ffffff;
        font-family: inherit;
        font-weight: 600;
        font-size: 15px;
        color: #182F5E;
    }

    .fp-sheet-close:active {
        background-color: #F4F6FA;
    }

</style>
